import React from 'react'
import { Tab, Tabs } from 'react-bootstrap';
import Constants from '../App/Variables/Constants';
import "bootstrap/dist/css/bootstrap.min.css";

const Fabric2 = ({ getSecondaryFabric, setFabric2Id, Fabric2Id, setFabric2Image, setRectangles, rectangles, setFillImageUrl }) => {

    const FabricType = [
        { id: 1, value: "velvet", label: "Velvet" },
        { id: 2, value: "genuin_leather", label: "Genuin Leather" },
        { id: 3, value: "cowhide", label: "Cowhide" },
        { id: 4, value: "exotic_leather", label: "Exotic Leather" },
        { id: 5, value: "linen", label: "Linen" },
      ];

    const getSecondaryFabrics = (e, fabric_type, fabricId) => {
        setFabric2Id(fabricId);
        setFillImageUrl(e)
        const img = new Image();
        img.crossOrigin = "Anonymous"; // Ensure cross-origin image loading

        img.src = e;  // Set fabric image source
        img.onload = () => {

            // Use the position and size from the rectangles (same as handleAddImage)
            let x = rectangles.length > 0 ? rectangles[0].x : 130;
            let y = rectangles.length > 0 ? rectangles[0].y : 90;
            let width = rectangles.length > 0 ? rectangles[0].width : 150;
            let height = rectangles.length > 0 ? rectangles[0].height : 150;

            // Align the fabric2 image with the size and position of the first rectangle (or custom size)
            if (rectangles[0]?.type === "art2") {
                // You can adjust the position and size based on the first "art2" rectangle, if necessary
                const art1 = rectangles.find(item => item.type === "art1");
                const filteredArray = rectangles.filter(item => item.type !== "art1");
                let data = art1 ? [art1, ...filteredArray] : filteredArray;
                setRectangles(data); // Reorder or modify the rectangles if necessary
            }

            // Update fabric2 image state with the same size and position as the added images
            setFabric2Image((prevImages) => [
                ...prevImages,
                {
                    id: `fabric2-${prevImages.length}`,
                    image: img,
                    x,   // Use the same x position as in handleAddImage
                    y,   // Use the same y position as in handleAddImage
                    width,  // Use the same width as in handleAddImage
                    height,  // Use the same height as in handleAddImage
                    ref: React.createRef(),
                },
            ]);
        };

        img.onerror = () => {
            console.error("Failed to load fabric image:", e);
        };
    };


    return (
        <div 
         className="row flex-column border border-3 border-dark overflow-hidden rounded-5 my-3"
         style={{ backgroundColor: "white" }}
        >
            <div className="col-12">
                <div className="row flex-column gap-4 py-4">
                    {Object.keys(getSecondaryFabric).length > 0 ? (
                        <Tabs
                            id="fabric2-tabs"
                            className="mb-3"
                            
                        >
                            {FabricType.map((fabricGroup, i) => (
                                <Tab
                                    key={i + 2}
                                    eventKey={fabricGroup.value} title={<span style={{ fontSize: "1rem" }}>{fabricGroup.label}</span>}>

                                    {getSecondaryFabric[fabricGroup.value].length > 0 ? ( // Check fabrics length for the group
                                        <div className="d-flex flex-wrap gap-2">
                                            {getSecondaryFabric[fabricGroup.value].map((fabric, j) => (
                                                <div key={j} style={{ position: "relative" }}>
                                                    {" "}
                                                    {/* Wrap each image in a div */}
                                                    <img
                                                        style={{ width: "80px", display: "inline", cursor: "pointer" }}
                                                        className={` ${Fabric2Id === fabric._id
                                                            ? "fabric2-selected"
                                                            : ""
                                                            }`}
                                                        src={Constants.imgDomain + fabric.image} // Use the correct image property
                                                        onClick={() =>
                                                            getSecondaryFabrics(
                                                                `${Constants.imgDomain + fabric.image}`,
                                                                `fabric2`,
                                                                `${fabric._id}`
                                                            )
                                                        }
                                                        alt={fabric.name} // Use fabric name for alt text
                                                    />
                                                    {Fabric2Id === fabric._id && ( // Conditionally render the cross
                                                        <span
                                                            style={{
                                                                position: "absolute",
                                                                top: 5, // Adjust as necessary
                                                                right: 5, // Adjust as necessary
                                                                color: "red", // Change color as needed
                                                                fontSize: "24px", // Adjust size as needed
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation(); // Prevent the click from triggering the image's onClick
                                                                setFabric2Image([]);
                                                                setFabric2Id(""); // Example to deselect the image
                                                            }}
                                                        >
                                                            ✖
                                                        </span>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <p style={{ color: "black" }}>No fabrics available in this category.</p>
                                    )}
                                </Tab>
                            ))}
                        </Tabs>
                    ) : (
                        <p>Loading fabrics...</p>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Fabric2